import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';
import { FlexRowCenterVertical } from '../../Defaults/Flexbox/Flexbox';
import { TextP } from '../../Defaults/Text';
import { StockInfo } from '../Product/StockInfo';

interface Props {
  title: string;
  value: string | number;
  hasBorderBottom?: boolean;
}

function InfoRow({ title, value, hasBorderBottom = false }: Props) {
  return (
    <Row hasBorderBottom={hasBorderBottom}>
      <Title>{title}</Title>
      {typeof value === 'number' ? (
        <StockInfo onStock={value} unit={'ks'} productInfo={true} />
      ) : (
        <Value>{value}</Value>
      )}
    </Row>
  );
}

const Row = styled(FlexRowCenterVertical)<{ hasBorderBottom?: boolean }>`
  height: ${rem(40)};
  padding: ${rem(13)} ${rem(24)};
  justify-content: flex-start;
  border-bottom: ${({ theme, hasBorderBottom }) =>
    hasBorderBottom ? theme.borders.primary : 0};
  font-family: ${({ theme }) => theme.font.primary};

  :nth-of-type(even) {
    background: ${({ theme }) => theme.colors.textRowBackground};
  }

  ${({ theme }) => theme.mediab.s450`
    padding: ${rem(13)} ${rem(16)};
  `}
`;

const Text = styled(TextP)`
  font-family: ${({ theme }) => theme.font.primary};
  font-size: ${rem(14)};
  line-height: ${rem(21)};
`;

const Title = styled(Text)`
  color: ${({ theme }) => theme.colors.textPrimary};
  margin-right: ${rem(32)};
  font-weight: 500;
  width: ${rem(150)};

  ${({ theme }) => theme.mediab.s450`
    width: ${rem(100)};
    margin-right: ${rem(8)};
  `}
`;

const Value = styled(Text)`
  color: black;
  font-weight: 300;
`;

export default InfoRow;
